import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './ConsultationForm.css';

const ConsultationForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    emailjs.send(
      'service_f1mdr3u',       //  EmailJS service ID
      'template_dgbu72e',      //  EmailJS template ID
      {
        user_email: formData.email,
        user_phone: formData.phone,
        message: formData.message,
      },
      'NXyZHG-1dAYo-zJKW'        // EmailJS public key
    ).then(
      () => {
        setFormData({ email: '', phone: '', message: '' });
      },
      (error) => {
        console.error('FAILED...', error);
      }
    );
  };

  return (
  <div className="consultation-container">
    <div className="form-wrapper">
      <h1>Schedule a Consultation</h1>
      <form onSubmit={handleSubmit}>
        <label>Email *</label>
        <input
          type="email"
          name="email"
          required
          value={formData.email}
          onChange={handleChange}
        />

        <label>Phone (optional)</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />

        <label>Your Message</label>
        <textarea
          name="message"
          rows={5}
          value={formData.message}
          onChange={handleChange}
        />

        <button type="submit">Send</button>
      </form>
    </div>
  </div>
);

};

export default ConsultationForm;
